
import { Linkedin } from "lucide-react";
import AnimatedCard from "@/components/AnimatedCard";

const AdvisorsSection = () => {
  return (
    <section className="py-20 bg-background relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.03] z-0"></div>
      <div className="container mx-auto px-6 relative z-10">
        <AnimatedCard animation="fade-in" className="mb-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Advisors You Can <span className="text-primary">Actually Talk To</span>
          </h2>
        </AnimatedCard>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <AnimatedCard animation="slide-in-left">
            <div className="space-y-6">
              <p className="text-lg text-gray-300">
                DocketLabs isn't a faceless firm. We're a small, experienced team that works directly 
                with you — no handoffs, no vague strategy decks. We've led legal tech projects, built AI 
                training programs, and advised firms across practice areas. If you're wondering what's 
                possible and how to achieve it, we'll help you find out.
              </p>
              
              <div className="flex items-center gap-2 pt-4">
                <p className="font-medium">Follow us on</p>
                <a 
                  href="https://www.linkedin.com/company/docketlabs/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="flex items-center text-primary hover:text-primary/80 transition-colors"
                >
                  <Linkedin className="h-5 w-5 mr-2" />
                  <span>LinkedIn</span>
                </a>
                <span>for practical AI insights.</span>
              </div>
            </div>
          </AnimatedCard>
          
          <AnimatedCard animation="slide-in-right" delay={200}>
            <div className="rounded-2xl overflow-hidden shadow-xl border border-white/10 glow-blue">
              <img alt="Joey Layne - DocketLabs Advisor" className="w-full h-auto" src="/lovable-uploads/Joey_Layne_2025.JPEG" />
            </div>
          </AnimatedCard>
        </div>
      </div>
    </section>
  );
};

export default AdvisorsSection;
